import React from 'react';
import Location from './Location';
import { FieldProps, Storage } from '../../types';

const StorageLocation: React.FC<FieldProps<Storage>> = ({ record }) => {
    // const storageRecord =
    //     record &&
    //     record.storagerecords &&
    //     !!record.storagerecords.length &&
    //     record.storagerecords[0];
    // const storageRecord =
    // record &&
    // record.storagerecords &&
    // !!record.storagerecords.length &&
    // record.storagerecords.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0];
    const storageRecord =
        record &&
        record.storagerecords &&
        !!record.storagerecords.length &&
        record.storagerecords.sort(
            (a, b) =>
                new Date(b.updatedAt).getTime() -
                new Date(a.updatedAt).getTime()
        )[0];

    if (storageRecord) {
        if (storageRecord.status === 'out') {
            return <span>OUT</span>;
        }

        if (storageRecord.status === 'in' && storageRecord.locationId) {
            return <Location record={storageRecord} label="Location" />;
        }

        return <span>IN</span>;
    }

    return null;
};

export default StorageLocation;
